import BlockLogos from './logos'

export default BlockLogos
